export default "__VITE_PUBLIC_ASSET__5e5ea6c2__"